export type LiabilityFormState = {
	insuranceProvider: string;
	policyNumber: string;
	validFrom: string;
	expiryDate: string;
};

export type FoodLicenseFormState = {
	licenseType: 'Temporary' | 'Mobile';
	councilRegionId: string;
	licenseNumber: string;
	expiryDate: string;
};

export type LiabilityFormErrors = Partial<Record<keyof LiabilityFormState, string>>;

export type FoodLicenseFormErrors = Partial<Record<keyof FoodLicenseFormState, string>>;

export const INITIAL_LIABILITY_FORM: LiabilityFormState = {
	insuranceProvider: '',
	policyNumber: '',
	validFrom: '',
	expiryDate: '',
};

export const INITIAL_FOOD_FORM: FoodLicenseFormState = {
	licenseType: 'Temporary',
	councilRegionId: '0',
	licenseNumber: '',
	expiryDate: '',
};
